export default __webpack_public_path__ + "static/Hero_08_Innovation-3f96e95fbf08c1201b4f92624e985d7d.jpg";